<template>
  <layout>
    <page-header :actions="actions" :header="$t('managers.title')" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps" />
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import { create } from 'vue-modal-dialogs'
import AddManager from './AddManager'
import ManagersApi from './ManagersApi'

const resourceBase = 'managers'

export default {
  name: 'ManagersIndex',

  components: {
    AdminTable,
  },

  data() {
    return {
      // Page header actions
      actions: [
        {
          id: 'create',
          text: this.$t('managers.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.$router.push({
              name: `${resourceBase}.create`,
            })
          },
        },
      ],

      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder() {
          return new ManagersApi().setParameters({
            context: 'list',
          })
        },
        columns: [
          {
            key: 'id',
            label: this.$t('general.id'),
            sortable: true,
          },
          {
            key: 'name',
            label: this.$t('managers.name'),
          },
          {
            key: 'email',
            label: this.$t('managers.email'),
            sortable: true,
          },
        ],

        rowActions: item => {
          const isAdmin = item.id === this.$account.id

          if (isAdmin) {
            return [
              {
                label: this.$t('managers.account_settings'),
                handler: () => {
                  this.$router.push({ name: 'account' })
                },
              },
              {
                label: this.$t('managers.logs'),
                variant: 'light',
                handler: () => {
                  this.$router.push({
                    name: 'managers.logs',
                    params: { manager_id: item.id },
                  })
                },
              },
            ]
          } else {
            return [
              'edit',
              'delete',
              {
                label: this.$t('managers.logs'),
                variant: 'light',
                handler: () => {
                  this.$router.push({
                    name: 'managers.logs',
                    params: {
                      manager_id: item.id,
                    },
                  })
                },
              },
            ]
          }
        },

        bulkActions: () => {
          return []
        },
      },
    }
  },

  created() {
    this.addManager = create(AddManager)
  },
}
</script>
